<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { onMount } from "svelte";
    import { Link } from "svelte-routing";
    export let settings;

    let isOpen = false;
    const handleClick = (event) => {
        isOpen = !isOpen;
        event.preventDefault();
    };
    onMount(() => {
        const handleClickOutside = (event) => {
            if (isOpen && !event.target.closest(".dropdown")) {
                isOpen = false;
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    });
</script>

<li class="nav-item dropdown" id="nav-einstellungen" style="flex-grow:0;white-space: nowrap;">
    <a
        class="nav-link dropdown-toggle navbar-text-custom"
        href="einstellungen"
        id="verwaltung_dropdown"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded={isOpen}
        on:click={handleClick}
        >Einstellungen</a
    >
    <a
        class="nav-link dropdown-toggle navbar-icon"
        href="einstellungen"
        id="verwaltung_dropdown"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded={isOpen}
        on:click={handleClick}
        ><i class="fa-solid fa-gear" style="font-size: 18px;"></i></a
    >
    <div
        class="dropdown-menu {isOpen ? 'show' : ''}"
        aria-labelledby="verwaltung_dropdown"
        id="dropwdown-settings"
    >
        {#each settings as item (item.id)}
            <Link class="dropdown-item" to={item.url}>{item.name}</Link>
        {/each}
    </div>
</li>
